/**
 * Populate Mustache with our preloaded templates.
 */
Rover.mustacheTemplates = Rover.mustacheTemplates || {};
Mustache.TEMPLATES = Rover.mustacheTemplates;



//////////////////
// WEBPACK FOOTER
// ./js/vendor/mustache_config.js
// module id = 2194
// module chunks = 71